import React from "react";
import {Container, Header, Icon} from "semantic-ui-react";
import AppListPage from "../../common/AppListPage";
import {SurveyCampaignModel, SurveyCampaignState, SurveyCampaignStateToString} from "../model/SurveyCampaignModel";
import {SurveyCampaignListOptions} from "../model/SurveyCampaignListOptions";
import {SurveyCampaignDataProvider} from "../service/SurveyCampaignDataProvider";
import SurveyCampaignDetails from "./SurveyCampaignDetails";
import {ColumnFormat} from "../../common/AppListDataGrid";
import styles from "../result/index.module.css";
import {hasRole, UserRole} from "../../../helpers/UserRole";

interface Props {
}

const SurveyCampaignList = (props: Props) => {
    return <Container fluid>
        <Header attached> <Icon name="paper plane outline"/>Кампании</Header>
        <AppListPage<SurveyCampaignModel, SurveyCampaignListOptions>
            provider={new SurveyCampaignDataProvider()}
            getDetailsComponent={(context) => <SurveyCampaignDetails context={context}/>}
            columns={[
                {key: "name", name: "Наименование", filterable: true},
                {
                    key: "state", name: "Состояние", accessor: (x) => SurveyCampaignStateToString(x.state),
                    filterable: true,
                    filterableOptions: {
                        dropdownItems: Object.values(SurveyCampaignState)
                            .map((x: SurveyCampaignState) => ({
                                value: x,
                                text: SurveyCampaignStateToString(x),
                                className: getStateClassName(x)
                            }))
                    },
                },
                {key: "formName", name: "Анкета", accessor: (item) => item.form.name, filterable: true},
                {key: "created", name: "Дата создания", format: ColumnFormat.datetime},
                {key: "startDate", name: "Дата начала", format: ColumnFormat.datetime},
                {key: "endDate", name: "Дата окончания", format: ColumnFormat.datetime}
            ]}
            getDisabledButtons={(focusedItem?: SurveyCampaignModel) => {
                let result: string[] = [];
                if (!focusedItem)
                    result.push('view', 'edit', 'delete', 'save');
                else if (focusedItem!.state == SurveyCampaignState.completed
                    || focusedItem.state == SurveyCampaignState.executing) result.push("save", "edit", "delete")
                if (hasRole(UserRole.OBSERVER)) result.push('edit', 'delete', 'add', 'load', 'save');
                return result;
            }
            }
        />
    </Container>;
}

function getStateClassName(state: SurveyCampaignState) {
    switch (state) {
        case SurveyCampaignState.pending:
            return styles.cell_state_pending;
        case SurveyCampaignState.executing:
            return styles.cell_state_executing;
        case SurveyCampaignState.completed:
            return styles.cell_state_completed;
        case SurveyCampaignState.cancelled:
            return styles.cell_state_cancelled;
        case SurveyCampaignState.error:
            return styles.cell_state_error;
    }
}

export default SurveyCampaignList;